export function hoursOnly(minutes: number): string {
  const hours = minutes / 60;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1).replace('.', ',')} ч`;
}

export type HoursInput = { kind: 'empty' } | { kind: 'invalid' } | { kind: 'ok'; minutes: number };

export function parseHours(raw: string): HoursInput {
  const text = raw.trim();
  if (!text) return { kind: 'empty' };
  const value = text.replace(',', '.').replace(/\s*[чh]$/i, '');
  if (!/^(\d+(\.\d*)?|\.\d+)$/.test(value)) return { kind: 'invalid' };
  return { kind: 'ok', minutes: Math.round(Number(value) * 60) };
}
